import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ButtonWithSpinner, CountryFlag, SequenceNumber, shipmentStatuses, Text } from '@reveni-io/reveni-ui'

import CustomsChip from '../CustomsChip/CustomsChip'
import InternationalChip from '../InternationalChip/InternationalChip'
import MoreActionsButton from '../MoreActionsButton/MoreActionsButton'
import ParcelTypeChip from '../ParcelTypeChip/ParcelTypeChip'
import PrepareParcelButton from '../PrepareParcelButton/PrepareParcelButton'
import * as Styles from './styles'

const ParcelInfoHeader = ({
  orderName,
  parcelType,
  isExchange,
  isInternational,
  withCustoms,
  senderAddress,
  recipientAddress,
  onPrepareParcel,
  onSplitParcel,
  allowPrepareParcel,
  allowAmendPackingStatus,
  status,
  onGenerateLabel,
  generatingLabel,
  shippingSkipPacking,
  onAutoPrepareParcel,
  preparingParcel,
  sequenceNumber,
  parcelsInOrder,
  openEditOutboundDestinationAddressModal,
  allowEditOutboundDestinationAddress,
  openSendEmailModalForContactCustomer,
  openSendEmailModalForContactCarrier,
  allowSendEmail,
  openEditOutboundOriginLocationModal,
  allowEditOutboundOriginLocation,
  openEditInboundOriginAddressModal,
  allowEditInboundOriginAddress,
  openEditInboundDestinationLocationModal,
  allowEditInboundDestinationLocation,
  openEditCarrierServiceModal,
  allowEditCarrierService,
  showMoreActions = true,
  openResetParcelModal,
  allowResetParcel,
  openCancelParcelModal,
  allowCancelParcel,
  allowSplitParcel,
  isInbound,
  onClickCarrierTrackingPage,
  displayCarrierTrackingPageAction,
  onClickViewInStore,
  viewInStoreUrl,
  onClickOrderTrackingPage,
  orderTrackingPageUrl,
  onOpenClaim,
  allowOpenClaim,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.MainContainer>
      <Styles.InfoContainer>
        <Text type="titleL" color={theme.colors.outline.default}>
          {orderName}
        </Text>
        <SequenceNumber position={sequenceNumber} total={parcelsInOrder} />
        <ParcelTypeChip type={parcelType} isExchange={isExchange} />
        {isInternational && <InternationalChip />}
        {withCustoms && <CustomsChip />}
        <CountryFlag code={senderAddress?.country?.code} />
        {isInternational && <CountryFlag code={recipientAddress?.country?.code} />}
      </Styles.InfoContainer>
      <Styles.ActionsContainer>
        <PrepareParcelButton
          allowPrepareParcel={allowPrepareParcel}
          shippingSkipPacking={shippingSkipPacking}
          onAutoPrepareParcel={onAutoPrepareParcel}
          onPrepareParcel={onPrepareParcel}
          preparingParcel={preparingParcel}
        />
        {showMoreActions && (
          <MoreActionsButton
            onPrepareParcel={onPrepareParcel}
            onSplitParcel={onSplitParcel}
            allowPrepareParcel={allowPrepareParcel}
            allowAmendPackingStatus={allowAmendPackingStatus}
            openEditOutboundDestinationAddressModal={openEditOutboundDestinationAddressModal}
            allowEditOutboundDestinationAddress={allowEditOutboundDestinationAddress}
            openSendEmailModalForContactCustomer={openSendEmailModalForContactCustomer}
            openSendEmailModalForContactCarrier={openSendEmailModalForContactCarrier}
            allowSendEmail={allowSendEmail}
            openEditOutboundOriginLocationModal={openEditOutboundOriginLocationModal}
            allowEditOutboundOriginLocation={allowEditOutboundOriginLocation}
            openEditInboundOriginAddressModal={openEditInboundOriginAddressModal}
            allowEditInboundOriginAddress={allowEditInboundOriginAddress}
            openEditInboundDestinationLocationModal={openEditInboundDestinationLocationModal}
            allowEditInboundDestinationLocation={allowEditInboundDestinationLocation}
            openEditCarrierServiceModal={openEditCarrierServiceModal}
            allowEditCarrierService={allowEditCarrierService}
            openResetParcelModal={openResetParcelModal}
            allowResetParcel={allowResetParcel}
            openCancelParcelModal={openCancelParcelModal}
            allowCancelParcel={allowCancelParcel}
            allowSplitParcel={allowSplitParcel}
            isInbound={isInbound}
            onClickCarrierTrackingPage={onClickCarrierTrackingPage}
            displayCarrierTrackingPageAction={displayCarrierTrackingPageAction}
            onClickViewInStore={onClickViewInStore}
            viewInStoreUrl={viewInStoreUrl}
            onClickOrderTrackingPage={onClickOrderTrackingPage}
            orderTrackingPageUrl={orderTrackingPageUrl}
            onOpenClaim={onOpenClaim}
            allowOpenClaim={allowOpenClaim}
          />
        )}
        {shipmentStatuses.packed === status && (
          <ButtonWithSpinner
            onClick={onGenerateLabel}
            defaultLabel={t('Generar etiquetas')}
            loadingLabel={t('Generar etiquetas')}
            disabled={generatingLabel}
            loading={generatingLabel}
          />
        )}
      </Styles.ActionsContainer>
    </Styles.MainContainer>
  )
}

export default ParcelInfoHeader
